import {
  ATTRIBUTE_BRAND,
  ATTRIBUTE_PRODUCT_TYPE,
  ATTRIBUTE_DESCRIPTION,
  ATTRIBUTE_PICTURE,
  ATTRIBUTE_PRICE,
  ATTRIBUTE_TITLE,
  VARIANT_ATTRIBUTE_ITEM_COST,
  ATTRIBUTE_INVENTORY,
  VARIANT_ATTRIBUTE_TAXABLE,
  ATTRIBUTE_PRODUCT_CATEGORY,
  VARIANT_ATTRIBUTE_INVENTORY_LOCATION,
  VARIANT_ATTRIBUTE_SKU, VARIANT_ATTRIBUTE_BARCODE
} from "./attributeTypes.js";

export const missingAttributesOptions = [
  { label: "Missing title", value: ATTRIBUTE_TITLE },
  { label: "Missing brand", value: ATTRIBUTE_BRAND },
  { label: "Missing product type", value: ATTRIBUTE_PRODUCT_TYPE },
  { label: "Missing description", value: ATTRIBUTE_DESCRIPTION },
  { label: "Missing price", value: ATTRIBUTE_PRICE },
  { label: "Missing picture", value: ATTRIBUTE_PICTURE },
  { label: "Missing product category", value: ATTRIBUTE_PRODUCT_CATEGORY },
  { label: "Missing cost of item", value: VARIANT_ATTRIBUTE_ITEM_COST },
  { label: "Missing inventory location", value: VARIANT_ATTRIBUTE_INVENTORY_LOCATION },
  { label: "Missing SKU", value: VARIANT_ATTRIBUTE_SKU },
  { label: "Missing barcode", value: VARIANT_ATTRIBUTE_BARCODE },
  { label: "Inventory is not tracked", value: ATTRIBUTE_INVENTORY },
  { label: "Variant is not taxable", value: VARIANT_ATTRIBUTE_TAXABLE }
];
